var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFriendMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_590_9169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5664 18.75H2.35157C1.29297 18.75 0.539067 17.7188 0.863286 16.7109L2.14844 12.6953C2.56251 11.4102 3.97266 10.7383 5.23047 11.2266C6.06641 11.5508 7.14063 11.8047 8.45313 11.8047C9.76563 11.8047 10.8438 11.5508 11.6758 11.2266C12.9375 10.7383 14.3477 11.4063 14.7578 12.6953L16.043 16.7109C16.3789 17.7188 15.625 18.75 14.5664 18.75Z",
    fill: "#F2F3F5",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 10.3047C10.6852 10.3047 12.4883 8.50158 12.4883 6.27734C12.4883 4.0531 10.6852 2.25 8.46094 2.25C6.2367 2.25 4.43359 4.0531 4.43359 6.27734C4.43359 8.50158 6.2367 10.3047 8.46094 10.3047Z",
    fill: "#F2F3F5",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 6.99219H17.8594V5.71094C17.8594 5.12109 17.3828 4.64453 16.793 4.64453C16.2031 4.64453 15.7266 5.12109 15.7266 5.71094V6.99219H14.4453C13.8555 6.99219 13.3789 7.46875 13.3789 8.05859C13.3789 8.64844 13.8555 9.125 14.4453 9.125H15.7266V10.4062C15.7266 10.9961 16.2031 11.4727 16.793 11.4727C17.3828 11.4727 17.8594 10.9961 17.8594 10.4062V9.125H19.1406C19.7305 9.125 20.207 8.64844 20.207 8.05859C20.2109 7.46875 19.7305 6.99219 19.1406 6.99219Z",
    fill: "#F2F3F5",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_590_9169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendMenu);
export default __webpack_public_path__ + "static/media/Friend-menu.9755ab3e7958a8f3afee96445ef3835c.svg";
export { ForwardRef as ReactComponent };